<span
  class="pg-button-content-wrapper grit-button-content-wrapper"
  [style.fontWeight]="styleOverrides?.fontWeight"
  [style.fontFamily]="styleOverrides?.fontFamily"
>
  <ng-container *ngIf="!this.loading; else loadingTpl">
    <ng-content></ng-content>
  </ng-container>
  <ng-template #loadingTpl>
    <pg-spinner size="24"></pg-spinner>
  </ng-template>
</span>
